export default __webpack_public_path__ + "static/media/PepperlFuchs1.c47f2ac4.png";